var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-view pa-4"},[_c('local-login-form',{attrs:{"loading":_vm.isSendingInfo},on:{"submit":function (fields) { return _vm.submitUserCredentials(fields); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }